<template>
  <header class="site-header" :class="{ 'is-scrolled': isScrolled, 'is-hidden': isHidden }">
    <a class="skip-link" href="#main-content">{{ $t('nav.skipToContent') }}</a>

    <!-- Bilah kemajuan gulir -->
    <div class="scroll-progress" :style="{ '--scroll-progress': scrollProgress }" aria-hidden="true"></div>

    <div class="app-container site-header__inner">
      <router-link to="/" class="site-header__brand" @click="closeMenu">
        <BrandLogo size="md" />
      </router-link>

      <nav class="site-nav" :aria-label="$t('nav.mainNav')">
        <router-link to="/" class="site-nav__link" exact-active-class="is-active">
          {{ $t('nav.home') }}
        </router-link>
        <router-link to="/detail" class="site-nav__link" active-class="is-active">
          {{ $t('nav.tournaments') }}
        </router-link>
        <router-link to="/schedule" class="site-nav__link" active-class="is-active">
          {{ $t('nav.schedule') }}
        </router-link>
        <router-link to="/about-us" class="site-nav__link" active-class="is-active">
          {{ $t('nav.about') }}
        </router-link>
      </nav>

      <div class="site-header__actions">
        <LanguageSwitcher class="site-header__hide-mobile" />
        <ThemeToggle class="site-header__theme-toggle" />

        <router-link
          to="/registration"
          class="ui-btn ui-btn--primary ui-btn--sm site-header__hide-mobile"
        >
          <i class="bi bi-pencil-square" aria-hidden="true"></i>
          {{ $t('nav.register') }}
        </router-link>

        <router-link
          v-if="!isAuthenticated"
          to="/admin/login"
          class="ui-btn ui-btn--secondary ui-btn--sm site-header__hide-mobile"
        >
          <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
          {{ $t('nav.login') }}
        </router-link>
        <router-link
          v-else
          to="/admin"
          class="ui-btn ui-btn--secondary ui-btn--sm site-header__hide-mobile"
        >
          <i class="bi bi-speedometer2" aria-hidden="true"></i>
          {{ $t('nav.dashboard') }}
        </router-link>

        <button
          type="button"
          class="site-header__burger"
          :class="{ 'is-open': menuOpen }"
          :aria-label="menuOpen ? $t('nav.closeMenu') : $t('nav.openMenu')"
          :aria-expanded="menuOpen"
          aria-controls="mobile-nav"
          @click="menuOpen = !menuOpen"
        >
          <span class="site-header__burger-bar"></span>
          <span class="site-header__burger-bar"></span>
          <span class="site-header__burger-bar"></span>
        </button>
      </div>
    </div>

    <!--
      Menu ponsel DIPINDAHKAN ke <body> lewat Teleport.

      Selama ini ia berada di dalam <header>, dan header itu memakai
      `backdrop-filter: blur(...)`. Properti tersebut membuat elemen menjadi
      "containing block" bagi seluruh keturunannya yang `position: fixed` —
      sama seperti `transform` dan `filter`. Akibatnya `.mobile-nav` yang
      ditulis `top: header; bottom: 0` tidak lagi mengukur diri terhadap
      layar, melainkan terhadap header yang tingginya cuma 64px. Menunya
      menyusut jadi sebuah kotak pendek dan isinya terpotong.

      Teleport mengeluarkannya dari header sepenuhnya, sehingga `fixed`
      kembali berarti "terhadap layar". Tidak ada gaya yang perlu diakali.
    -->
    <Teleport to="body">
      <transition name="fade">
        <div
          v-if="menuOpen"
          class="mobile-nav__tirai"
          aria-hidden="true"
          @click="closeMenu"
        ></div>
      </transition>

      <transition name="slide-down">
        <nav v-if="menuOpen" id="mobile-nav" class="mobile-nav" :aria-label="$t('nav.mainNav')">
          <div class="app-container mobile-nav__inner">
            <router-link to="/" class="mobile-nav__link" @click="closeMenu">
              <i class="bi bi-house" aria-hidden="true"></i>{{ $t('nav.home') }}
            </router-link>
            <router-link to="/detail" class="mobile-nav__link" @click="closeMenu">
              <i class="bi bi-trophy" aria-hidden="true"></i>{{ $t('nav.tournaments') }}
            </router-link>
            <router-link to="/registration" class="mobile-nav__link" @click="closeMenu">
              <i class="bi bi-pencil-square" aria-hidden="true"></i>{{ $t('nav.register') }}
            </router-link>
            <router-link to="/schedule" class="mobile-nav__link" @click="closeMenu">
              <i class="bi bi-calendar-week" aria-hidden="true"></i>{{ $t('nav.schedule') }}
            </router-link>
            <router-link to="/about-us" class="mobile-nav__link" @click="closeMenu">
              <i class="bi bi-info-circle" aria-hidden="true"></i>{{ $t('nav.about') }}
            </router-link>

            <div class="mobile-nav__footer">
              <div class="mobile-nav__prefs">
                <LanguageSwitcher />
                <ThemeToggle />
              </div>
              <router-link
                to="/registration"
                class="ui-btn ui-btn--primary ui-btn--lg ui-btn--block mb-2"
                @click="closeMenu"
              >
                <i class="bi bi-pencil-square" aria-hidden="true"></i> {{ $t('nav.register') }}
              </router-link>
              <router-link
                :to="isAuthenticated ? '/admin' : '/admin/login'"
                class="ui-btn ui-btn--secondary ui-btn--lg ui-btn--block"
                @click="closeMenu"
              >
                {{ isAuthenticated ? $t('nav.dashboard') : $t('nav.login') }}
              </router-link>
            </div>
          </div>
        </nav>
      </transition>
    </Teleport>
  </header>
</template>

<script>
import ThemeToggle from '@/components/ui/ThemeToggle.vue';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher.vue';
import BrandLogo from '@/components/ui/BrandLogo.vue';

export default {
  name: 'MainHeader',

  components: { ThemeToggle, LanguageSwitcher, BrandLogo },

  data() {
    return {
      isScrolled: false,
      isHidden: false,
      scrollProgress: 0,
      lastScroll: 0,
      menuOpen: false,
      ticking: false,
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },

  },

  watch: {
    $route() {
      this.closeMenu();
    },
    menuOpen(open) {
      document.body.style.overflow = open ? 'hidden' : '';
    },
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    document.addEventListener('keydown', this.handleEscape);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('keydown', this.handleEscape);
    document.body.style.overflow = '';
  },

  methods: {
    /*
     * Perhitungan dibungkus requestAnimationFrame agar hanya dijalankan
     * sekali per frame. Membaca scrollY dan tinggi dokumen langsung di
     * dalam handler scroll memaksa peramban menghitung ulang tata letak
     * puluhan kali per detik, dan itulah penyebab gulir terasa tersendat.
     */
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const y = window.scrollY;
        const tinggi = document.documentElement.scrollHeight - window.innerHeight;

        this.isScrolled = y > 8;
        this.scrollProgress = tinggi > 0 ? Math.min(y / tinggi, 1) : 0;

        // Sembunyikan header saat menggulir ke bawah, tampilkan saat naik.
        // Tidak berlaku di puncak halaman dan saat menu ponsel terbuka.
        if (!this.menuOpen && y > 300) {
          this.isHidden = y > this.lastScroll;
        } else {
          this.isHidden = false;
        }

        this.lastScroll = y;
        this.ticking = false;
      });
    },

    handleEscape(event) {
      if (event.key === 'Escape') this.closeMenu();
    },

    closeMenu() {
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: var(--z-header);
  background-color: var(--header-bg);
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  border-bottom: 1px solid transparent;
  transition: border-color var(--transition-base), box-shadow var(--transition-base),
              transform 400ms var(--ease-out-quart);
}

.site-header.is-scrolled {
  border-bottom-color: var(--border-subtle);
  box-shadow: var(--shadow-sm);
}

.site-header.is-hidden { transform: translateY(-100%); }

.site-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  height: var(--header-height);
}

@media (min-width: 768px) {
  .site-header__inner {
    gap: var(--space-4);
  }
}

.site-header__brand {
  flex-shrink: 0;
}

/* --- Navigasi layar lebar --- */
.site-nav {
  display: none;
  align-items: center;
}

@media (min-width: 992px) {
  .site-header__inner {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: var(--space-3);
  }

  .site-header__brand {
    justify-self: start;
  }

  .site-nav {
    display: flex;
    justify-self: center;
    margin-left: 0;
    gap: 3px;
  }

  .site-nav__link {
    padding: 6px 9px;
    font-size: 0.84rem;
    white-space: nowrap;
  }

  .site-header__actions {
    justify-self: end;
    margin-left: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .site-header__actions .ui-btn--sm {
    padding: 6px 11px;
    font-size: 0.8125rem;
    white-space: nowrap;
  }

  .site-header__actions :deep(.lang-switcher__trigger) {
    height: 34px;
    padding-inline: 8px;
  }

  .site-header__actions :deep(.theme-toggle__trigger) {
    width: 34px;
    height: 34px;
  }
}

@media (min-width: 1200px) {
  .site-nav {
    gap: var(--space-1);
  }

  .site-nav__link {
    padding: 8px 13px;
    font-size: var(--text-sm);
  }

  .site-header__actions {
    gap: var(--space-2);
  }

  .site-header__actions .ui-btn--sm {
    padding: 8px 14px;
    font-size: var(--text-sm);
  }

  .site-header__actions :deep(.lang-switcher__trigger) {
    height: 40px;
    padding-inline: var(--space-3);
  }

  .site-header__actions :deep(.theme-toggle__trigger) {
    width: 40px;
    height: 40px;
  }
}

.site-nav__link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-weight: 600;
  color: var(--text-secondary);
  border-radius: var(--radius-md);
  white-space: nowrap;
  transition: color var(--transition-fast);
}

/* Garis api tumbuh dari tengah saat disentuh */
.site-nav__link::after {
  content: '';
  position: absolute;
  left: var(--space-3); right: var(--space-3);
  bottom: 6px;
  height: 2px;
  background: var(--grad-flame-soft);
  border-radius: var(--radius-full);
  transform: scaleX(0);
  transition: transform 320ms var(--ease-out-expo);
}

.site-nav__link:hover { color: var(--text-primary); }
.site-nav__link:hover::after { transform: scaleX(1); }

.site-nav__link.is-active { color: var(--text-primary); }
.site-nav__link.is-active::after { transform: scaleX(1); }

.site-nav__link--button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.site-nav__chevron {
  font-size: 0.7rem;
  transition: transform var(--transition-base);
}
.site-nav__chevron.is-open { transform: rotate(180deg); }

.site-nav__dropdown { position: relative; }

/* --- Aksi kanan --- */
.site-header__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-left: auto;
}

.site-header__theme-toggle {
  display: inline-flex;
}

.site-header__hide-mobile { display: none; }
@media (min-width: 992px) { .site-header__hide-mobile { display: inline-flex; } }

/* Tombol menu ponsel bergaya garis yang berubah jadi silang */
.site-header__burger {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  padding: 0 10px;
  background: transparent;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.site-header__burger:focus-visible {
  outline: 2px solid var(--accent, #E84808);
  outline-offset: 2px;
}

@media (min-width: 992px) { .site-header__burger { display: none; } }

.site-header__burger-bar {
  display: block;
  height: 2px;
  width: 100%;
  background: var(--text-primary);
  border-radius: var(--radius-full);
  transition: transform var(--transition-base), opacity var(--transition-fast);
}

.site-header__burger.is-open .site-header__burger-bar:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.site-header__burger.is-open .site-header__burger-bar:nth-child(2) { opacity: 0; }
.site-header__burger.is-open .site-header__burger-bar:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* --- Navigasi ponsel ---
   Elemen ini di-Teleport ke <body>, jadi tidak ada lagi leluhur yang bisa
   membatasi `position: fixed`-nya. Lihat catatan panjang di template. */
.mobile-nav {
  position: fixed;
  top: var(--header-height);
  left: 0; right: 0; bottom: 0;
  z-index: var(--z-overlay);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  /* Ruang aman bawah: pada iPhone, bilah gestur menutupi ~34px terbawah,
     sehingga tombol terakhir jadi sulit disentuh tanpa tambahan ini. */
  padding-block: var(--space-3) calc(var(--space-10) + var(--safe-bottom));
  background-color: var(--bg-base);
  border-top: 1px solid var(--border-subtle);
}

/* Menu ini hanya untuk layar sempit. Tanpa batas ini, membuka menu lalu
   memutar ponsel ke posisi mendatar (atau membuka di tablet) meninggalkan
   panel yang menutupi halaman sementara tombol penutupnya sudah hilang. */
@media (min-width: 992px) {
  .mobile-nav,
  .mobile-nav__tirai { display: none; }
}

/* Tirai gelap di belakang menu: memberi batas yang jelas antara menu dan
   halaman, dan menyediakan area sentuh untuk menutup. */
.mobile-nav__tirai {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-overlay) - 1);
  background: rgb(0 0 0 / 0.5);
}

.mobile-nav__link {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 44px;
  padding: 0.55rem var(--space-2);
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-subtle);
}

.mobile-nav__link i { color: var(--accent); width: 20px; }

.mobile-nav__link--nested {
  min-height: 38px;
  padding-left: var(--space-5);
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.mobile-nav__link--more {
  gap: var(--space-2);
  font-weight: 700;
  color: var(--text-brand);
}

.mobile-nav__section {
  margin: var(--space-6) 0 var(--space-2);
  padding-inline: var(--space-2);
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.mobile-nav__footer {
  margin-top: var(--space-8);
  padding-top: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.mobile-nav__prefs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

/* --- Transisi --- */
.popover-enter-active, .popover-leave-active {
  transition: opacity var(--transition-fast), transform var(--transition-base);
}
.popover-enter-from, .popover-leave-to { opacity: 0; transform: translateY(-10px) scale(0.98); }

.slide-down-enter-active, .slide-down-leave-active {
  transition: opacity var(--transition-base), transform var(--transition-base);
}
.slide-down-enter-from, .slide-down-leave-to { opacity: 0; transform: translateY(-12px); }

.fade-enter-active, .fade-leave-active { transition: opacity var(--transition-base); }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* Hormati preferensi sistem: sebagian orang merasa pusing oleh animasi
   yang bergeser. Menunya tetap muncul, hanya tanpa gerakan. */
@media (prefers-reduced-motion: reduce) {
  .popover-enter-active, .popover-leave-active,
  .slide-down-enter-active, .slide-down-leave-active,
  .fade-enter-active, .fade-leave-active { transition: none; }
  .slide-down-enter-from, .slide-down-leave-to { transform: none; }
}
</style>
